import OptionalGoals from './component'
export default OptionalGoals
